<template>
  <b-row>
    <b-col md="12" class="mb-4">
      <div style="float:right">
        <b-button variant="info" style="color:#ffffff" v-bind:href="'#/contents/form?status=insert'"><i class="fa fa-hand-o-up"></i> 신규등록</b-button>
      </div>
    </b-col>
    <b-col md="12">
      <b-card class="status-card">
        <b-row>
          <b-col sm="2">
            <span class="card-title wise-card-title">콘텐츠 현황</span>
          </b-col>
          <b-col sm="10">
            <b-row v-show="statusLoding">
              <b-col sm="5"></b-col>
              <b-col sm="5" class="pt-4 pb-4">
                <PulseLoader color="#20a8d8"></PulseLoader>
              </b-col>
            </b-row>
            <b-row v-show="!statusLoding">
              <b-col sm="4">
                <div class="callout callout-info">
                  <span class="text-muted" style="font-size: 15px"
                  >총 콘텐츠 수</span
                  >
                  <br />
                  <strong class="h4">{{
                    totalReportCount
                    | numberComma
                    }}</strong>
                </div>
              </b-col>
              <b-col sm="4">
                <div class="callout callout-info">
                  <span class="text-muted" style="font-size: 15px"
                  >무료 콘텐츠</span
                  >
                  <br />
                  <strong class="h4">{{
                    totalFreeReportCount
                    | numberComma
                    }}</strong>
                </div>
              </b-col>
              <b-col sm="4">
                <div class="callout callout-info">
                  <span class="text-muted" style="font-size: 15px"
                  >유료 콘텐츠</span
                  >
                  <br />
                  <strong class="h4">{{
                    totalPayReportCount
                    | numberComma
                    }}</strong>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>

      <b-card>
        <b-row class="pt-sm-1">
          <b-col sm="1">
            <span class="card-title wise-card-title">검색조건</span>
          </b-col>
          <b-col sm="1"><strong>검색어</strong></b-col>
          <b-col sm="8">
            <b-form-input id="basicText" type="text" v-model="queryParams.keyword" v-on:keyup="$event.keyCode === 13 ? findDrReportList() : ''" placeholder="검색어를 입력해주세요."></b-form-input>
          </b-col>
          <b-col sm="2" style="text-align: center;">
            <b-button type="submit" variant="primary" v-on:click="findDrReportList()" style="width: 100%;"> 검색</b-button>
          </b-col>
        </b-row>
        <b-row class="pt-sm-2">
          <b-col sm="1"></b-col>
          <b-col sm="1"><strong>등록일</strong></b-col>
          <b-col sm="3">
            <date-picker
              v-model="fullDateTmp"
              type="date"
              style="width: 100%;"
              range
              placeholder="조회기간 선택"
              :lang="datepickerLang"
            />
          </b-col>
          <b-col sm="6">
            <button type="button" class="btn btn-outline-primary" style="width: 61.72px;" v-on:click="dateRange('ALL')">전체</button>
            <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('1WEEK')">1주일</button>
            <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('1MONTH')">1개월</button>
            <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('6MONTH')">6개월</button>
            <button type="button" class="btn btn-outline-primary" style="width: 61.72px;" v-on:click="dateRange('1YEAR')">1년</button>
          </b-col>
        </b-row>
        <b-row class="pt-sm-2">
          <b-col sm="1"></b-col>
          <b-col sm="1"><strong>판매구분</strong></b-col>
          <b-col sm="8">
            <label class="col-form-label">
              <b-form-radio-group v-model="queryParams.sales_type">
                <b-form-radio value="all">전체</b-form-radio>
                <b-form-radio value="free">무료</b-form-radio>
                <b-form-radio value="pay">유료</b-form-radio>
              </b-form-radio-group>
            </label>
          </b-col>
        </b-row>
        <b-row class="pt-sm-2">
          <b-col sm="1"></b-col>
          <b-col sm="1"><strong>대메뉴</strong></b-col>
          <b-col sm="8">
            <b-button size="sm" class="mx-1" v-show="menuButtons.length > 0"
                      variant="outline-primary"
                      v-for="(categoryBtn, idx) in menuButtons"
                      :key="idx"
                      :pressed.sync="categoryBtn.state"
            >
              {{ categoryBtn.item_name }}
            </b-button>
          </b-col>
        </b-row>
      </b-card>
    </b-col>

    <b-col md="12">
      <b-card>
        <b-row>
          <b-col sm="12">
            <b-row>
              <b-col sm="4">
                <span class="pr-"><strong>검색결과 (총 {{this.searchReportCount}} 건)</strong></span>
                <b-button size="sm" variant="danger" v-on:click="drReportDelete()" :disabled="drDeleteRows.length == 0" :class="drDeleteRows.length != 0 ? 'mx-1 delete_button_on' : 'mx-1 delete_button_off'"><h5 style="margin-bottom:0px"><i class="fa fa-remove"></i> 삭제</h5></b-button>
                <b-button size="sm" variant="info" v-on:click="drReportDeleteClear()" :disabled="drDeleteRows.length == 0" :class="drDeleteRows.length != 0 ? 'mx-1 clear_button_on' : 'mx-1 clear_button_off'"><h5 style="margin-bottom:0px"><i class="fa fa-list"></i> 선택취소</h5></b-button>
              </b-col>
              <b-col sm="3"></b-col>
              <b-col sm="3"></b-col>
              <b-col md="2" class="my-1">
                <b-form-group label-cols-sm="5" label="" class="mb-0">
                  <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12" class="pt-sm-1">
            <b-row>
              <b-col sm="1"></b-col>
              <b-col sm="12">
                <b-table
                  striped
                  hover
                  :selectable="reportListSelect"
                  :select-mode="'multi'"
                  :fields="fieldItems"
                  :items="items"
                  :busy="items == 0"
                  :current-page="currentPage"
                  :per-page="perPage">
                  <div slot="table-busy" class="text-center my-2">
                    <PulseLoader color="#20a8d8" v-if="listStatusLoading"></PulseLoader>
                    <strong v-else>데이터가 없습니다.</strong>
                  </div>
                  <template slot="selectcheck" slot-scope="data">
                    <div style="width:30px">
                      <input type="checkbox" class="datarows" v-model="data.item.selectchecked" v-on:change="drListRows(data.item, $event.target)" style="vertical-align:middle; width:20px; height:20px">
                    </div>
                  </template>
                  <template slot="type_code_k" slot-scope="data">
                    <div style="width:95px">{{data.item.type_code_k}} <br> {{data.item.sub_type_code_k}}</div>
                  </template>
                  <template slot="type_code_k2" slot-scope="data">
                    <div style="width:140px">{{data.item.type_code_k2}} <br> {{data.item.sub_type_code_k2}}</div>
                  </template>
                  <template slot="report_name" slot-scope="data">
                    <div style="width:100%"><a href="javascript:void(0)" v-on:click="reportInfoGo(data.item)">{{data.item.report_name}}</a></div>
                  </template>
                  <!-- <template slot="categorytag" slot-scope="data">
                    <div v-html="data.item.categorytag" style="width:100px"></div>
                  </template> -->
                  <template slot="custom_date" slot-scope="data">
                    <div style="width:75px">{{data.item.custom_date}}</div>
                  </template>
                  <template slot="reg_date" slot-scope="data">
                    <div style="width:75px">{{data.item.reg_date}}</div>
                  </template>
                  <template slot="sales_name" slot-scope="data">
                    <div style="width:60px">
                      <span class="badge badge-success" style="font-size:15px" v-show="data.item.sales_type == 'free'">무료</span>
                      <span class="badge badge-danger" style="font-size:15px" v-show="data.item.sales_type == 'pay'">유료</span>
                    </div>
                  </template>
                  <template slot="price" slot-scope="data">
                    <div v-show="data.item.sales_type === 'free'" style="width:80px">0원
<!--                      </br>(<span style="width:17px; height:17px; background:#fff; font-weight:bold; font-size:10px; text-align:center; color:#ff500f; border-radius:20px; border:2px solid #ff500f; display:inline-block">R</span> {{Number(data.item.pointminus).toLocaleString()}})-->
                    </div>
                    <div v-show="data.item.sales_type === 'pay'" style="width:80px">{{Number(data.item.min_price).toLocaleString()}}원 ~ {{Number(data.item.max_price).toLocaleString()}}원
<!--                      <br/>(<span style="color:#ea0000">{{'구매 : '+Number(data.item.in_purchase_cnt).toLocaleString()}}</span>)-->
                    </div>
                  </template>
<!--                  <template slot="HEAD_down_cnt" slot-scope="data" v-show="false">-->
<!--                    <div><span>다운로드</span></div>-->
<!--                  </template>-->
<!--                  <template slot="down_cnt" slot-scope="data">-->
<!--                    <div>{{data.item.down_cnt}}</div>-->
<!--                  </template>-->
<!--                  <template slot="HEAD_attachments_file_count" slot-scope="data" v-show="false">-->
<!--                    <div style="width:80px"><span>비고</span></div>-->
<!--                  </template>-->
                  <template slot="attachments_file_count" slot-scope="data">
                    <div v-show="data.item.sales_type == 'free'" style="width:80px">첨부파일 <i class="fa fa-file-o fa-lg"> {{data.item.attachments_file_count}}</i></div>
                    <div v-show="data.item.sales_type == 'pay'" style="width:80px">옵션 : {{data.item.opt_cnt}}</br>패키지 : {{data.item.pkg_cnt}}</div>
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12" class="pt-sm-1">
            <b-row class="pb-sm-2">
              <b-col sm="1"></b-col>
              <b-col sm="12" class="my-1">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="listRows"
                  :per-page="perPage"
                  align="center"
                ></b-pagination>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <div style="float:right">
          <b-button variant="info" style="color:#ffffff" v-bind:href="'#/contents/form?status=insert'"><i class="fa fa-hand-o-up"></i> 신규등록</b-button>
        </div>
      </b-card>
    </b-col>
  </b-row>

</template>
<script>
import { codeAPI } from '../../common/code.js';
import swal from 'sweetalert2'
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import _ from "lodash";
import DatePicker from "vue2-datepicker";

const moment = require("moment");

export default {
  name: 'List',
  components: {
    PulseLoader,
    DatePicker,
  },
  data() {
    return {
      reportListSelect: false,
      dr_topdeth_code: '',
      dr_rtype: '',
      resultCateDatas: [], // code.js 각 코드들의 결과값
      menu_code: [], // 대메뉴
      myToggle: false,
      // totalRows: 30,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 30, 50, 100],
      drDeleteRows: [],
      searchData: {},
      queryParams: {
        menu_code: [], //대메뉴
        sales_type: 'all',
        type_code: 'all',
        start_date: '',
        end_date: '',
      },
      fieldItems: [{
        'selectcheck': {
          'label': '선택',
          'type' :'form-checkbox',
          'class': 'form-checkbox',
          'tdClass': 'text-vmiddle',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      },{
        'sales_name': {
          'label': '판매구분',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'dr_code': {
          'label': '보고서코드',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'type_code_k': {
          'label': '대분류',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'type_code_k2': {
          'label': '소분류',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'report_name': {
          'label': '보고서명',
          'thStyle': {
             'vertical-align': 'middle',
             'text-align': 'center'
          }
        }
      }, {
        'custom_date': {
          'label': '출시일 설정',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'reg_date': {
          'label': '등록일',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'price': {
          'label': '금액',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      },
      //   {
      //   'view_cnt': {
      //     'label': '조회수',
      //     'class': 'text-center',
      //     'thStyle': {
      //        'vertical-align': 'middle'
      //     }
      //   }
      // }, {
      //   'down_cnt': {
      //     'label': '다운로드 엑셀',
      //     'class': 'text-center',
      //     'thStyle': {
      //        'vertical-align': 'middle'
      //     }
      //   }
      // }, {
      //   'bestview_yn': {
      //     'label': '인기리포트',
      //     'class': 'text-center',
      //     'thStyle': {
      //        'vertical-align': 'middle'
      //     }
      //   }
      // }, {
      //   'reg_id': {
      //     'label': '등록자',
      //     'class': 'text-center',
      //     'thStyle': {
      //        'vertical-align': 'middle'
      //     }
      //   }
      // }, {
      //   'view_yn': {
      //     'label': '노출여부',
      //     'class': 'text-center',
      //     'thStyle': {
      //        'vertical-align': 'middle'
      //     }
      //   }
      // }, {
      //   'attachments_file_count': {
      //     'label': '첨부파일',
      //     'class': 'text-center',
      //     'thStyle': {
      //        'vertical-align': 'middle'
      //     }
      //   }
      // }
      ],
      items: [],
      menuButtons: [],
      totalReportCount: 0,
      totalPayReportCount: 0,
      totalFreeReportCount: 0,
      searchReportCount: 0,
      statusLoding: false,
      listStatusLoading : true,
      datepickerLang: {
        yearFormat: "YYYY년",
        monthFormat: "M월",
        days:["일","월","화","수","목","금","토"]
      },
      fullDateTmp: [],
    }
  },
  computed: {
    listRows() {
      return this.items.length
    }
  },
  watch: {
    'reportListSelect'() {
      this.drDeleteRows = [];
    }
  },
  mounted: function() {
    // /contents/trendbrief
    this.drDeleteRows = [];
    $(".datarows").prop("checked", false);
    this.getReportStatBySaleType()
    this.reportInit();
  },
  methods: {
    reportInit() {
      const token = sessionStorage.getItem("myToken");
      const self = this;
      // let drCodeArr = {};
      self.searchData = {};
      self.searchData.categoryNames = '';

      // drCodeArr = reportCodeReturn(self.$route.params.reporturltype);
      // self.$session.set('depth_top_name', drCodeArr.depth_top_name);
      // self.$session.set('dr_topdeth_code', drCodeArr.dr_topdeth);
      // self.$session.set('dr_unique_code', drCodeArr.dr_unique);

      // this.dr_menu_code = drCodeArr.dr_topdeth;

      if(this.menu_code === 'RPT_TYPE_4'){
        self.dr_rtype = 1;
      }else{
        self.dr_rtype = 0;
      }

      // 상단 셀렉트 박스 코드 조회
      //codeAPI.selectItemCodeList(self,this.dr_menu_code,3,"selectCateItems");

      setTimeout(function(){
        self.menu_code = [];
        self.menu_code.push({text: '전체',value: 'all'});
      }, 500);

      this.$http.get('/api/select/itemCodeList?access_token='+token + '&parentCode=RPT_TYPE')
      .then((result) => {
        let menuData = result.data;
        menuData.forEach(function (el, idx, arr){
          el.state = false;
        });
        this.menuButtons = menuData;
        self.findDrReportList();
      })
    },
    // 메소드명 : findDrReportList()
    // ### 리포트 조회 ###
    // 리포트를 DB테이블에서 조회한다.
    //
    // 최초작성 : 2016.05.31
    // 파라미터 :
    //  - parentCode(그룹코드 값)
    //  - depth(대분류,소분류 구분)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.05.31  황경현   최초작성
    // *************************
    findDrReportList() {

      var self = this;
      var menuParams = [];
      var menuNames = '';

      this.menuButtons.forEach(function (el, idx, arr){
        if(el.state){
          menuParams.push(el.item_code);
          menuNames += "<span class='badge badge-info' style='color:#ffffff; font-size:12px'>"+el.item_name+"</span>&nbsp;&nbsp;";
        }
      });

      this.queryParams.menu_code = menuParams;

      this.queryParams.r_type = this.dr_rtype;
      let token = sessionStorage.getItem("myToken");
      let param = encodeURI(JSON.stringify(this.queryParams));

      let data = new FormData();
      data.append('objs', param);

      this.$http.post('/api/select/drReportList?access_token=' + token, data, null)
        .then((result) => {

          self.items = result.data;
          this.searchReportCount = self.items.length.toLocaleString();

          self.items.forEach(function (el, idx, arr){
            el.rnum = self.items.length - (idx);
            el.selectchecked = false;
            // var categorydata = el.category_alldatas.split(',')
            // var categorytags = "";
            // categorydata.forEach(function (el, idx, arr){
            //   categorytags += "<span class='badge badge-info' style='color:#ffffff; font-size:12px'>"+el+"</span>&nbsp;&nbsp;"
            // });
            // el.categorytag = categorytags;
          });

          // self.selectCateItems.forEach(function (el, idx, arr){
          //   if(el.value == self.queryParams.type_code){
          //     self.searchData.typeCodeName = el.text;
          //   }
          // });
          self.searchData.menuNames = menuNames;
          self.searchData.startday = self.queryParams.start_date;
          self.searchData.endday = self.queryParams.end_date;
          self.searchData.keyword = self.queryParams.keyword;
          self.searchData.dayAllCheck = self.queryParams.day_code == 'dayall';

          this.listStatusLoading = false;

        })
    },
    drListRows(rows, target) {
      var self = this;
      if(rows.in_purchase_cnt > 0){
        rows.selectchecked = false;
        target.checked = false;
        swal.fire({
          type: 'warning',
          title: '보고서 삭제!',
          html: "<b>구매된 보고서는 삭제할수 없습니다.</br><span style='color:#ea0000'>구매건 수 : "+rows.in_purchase_cnt+"건</span></b>",
          showConfirmButton: true
        })
        return false;
      }else{
        self.drDeleteRows = [];
        self.items.forEach(function (el, idx, arr){
          if(el.selectchecked){
            self.drDeleteRows.push(el.dr_code);
          }
        });
      }
    },
    drReportDelete(){
      var self = this;
      swal.fire({
        title: '보고서 삭제!',
        // text: "기본정보 이외에 작성한 데이터는 모두 초기화 됩니다. "+messageValue+"로 변경하시겠습니까?",
        html: "<b>현재의 보고서와 옵션 및 각종 패키지 저장된 데이터</br> 모두 삭제 됩니다. 삭제하시겠습니까?</br><span style='color:#ea0000'>삭제 데이터 수 : "+self.drDeleteRows.length+"건</span></b>",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK'
      }).then((swalResult) => {
        if (swalResult.value) {
          // ok
          console.log(self.drDeleteRows);
          var token = sessionStorage.getItem("myToken");
          var param = encodeURI(JSON.stringify(self.drDeleteRows));
          var data = new FormData();
          data.append('drDelArr', param);

          self.$http.post('/api/delete/drReport?access_token='+token, data, null)
            .then((result) => {
              swal.fire({
                type: 'success',
                title: '<b>보고서가 삭제되었습니다.</b>',
                showConfirmButton: false,
                timer: 1000
              }).then(function() {
                self.drDeleteRows = [];
                $(".datarows").prop("checked", false);
                self.findDrReportList();
              });
          })
        }else{
          // cancel
        }
      })
    },
    drReportDeleteClear() {
      this.drDeleteRows = [];
      this.items.forEach(function (el, idx, arr){
        el.selectchecked = false;
      });
    },
    reportInfoGo(row) {
      // TODO 리포트 상세 가기 수정 필요
      var self = this;
      self.$session.set('reportDrcode', row.dr_code);
      location.href = '#/contents/editForm?dr_code='+row.dr_code;
    },
    dateMonthSelect (item) {
      var self = this;
      self.dateMonthButtons.forEach(function (el, idx, arr){
        if(el.item_code == item.item_code){
          el.state = true;
        }else{
          el.state = false;
        }
      });
      self.queryParams.day_code = item.item_code;
      var addDateCnt = 0;
      var dateSpilt;
      dateSpilt = item.item_code.split("|");
      setTimeout(function(){
        $('input[name="daterange"]').data('daterangepicker').setStartDate(moment().add(dateSpilt[0], dateSpilt[1]).format('YYYY-MM-DD'));
  		  $('input[name="daterange"]').data('daterangepicker').setEndDate(moment().format('YYYY-MM-DD'));
        self.queryParams.start_date = moment().add(dateSpilt[0], dateSpilt[1]).format('YYYY-MM-DD');
        self.queryParams.end_date = moment().format('YYYY-MM-DD');
      }, 0);
    },
    getReportStatBySaleType: function () {
      //콘텐츠 현황
      this.statusLoding = true;
      let token = sessionStorage.getItem("myToken");

      this.$http.get('/api/select/selectDrReportStatBySaleType?access_token='+token)
        .then(response => {
          this.totalPayReportCount = response.data.payReportCount.toLocaleString()
          this.totalFreeReportCount = response.data.freeReportCount.toLocaleString()
          this.totalReportCount = response.data.payReportCount + response.data.freeReportCount
          this.totalReportCount = this.totalReportCount.toLocaleString()

          this.statusLoding = false;
        })
    },
    dateRange(flag) {
      let endDate;
      let startDate;
      if(this.fullDateTmp.length === 0){
        endDate = new Date();
        startDate = new Date();
      }else{
        endDate = this.fullDateTmp[1];
        startDate = _.clone(this.fullDateTmp[1]);
      }

      if(flag == '1WEEK'){
        startDate.setDate(endDate.getDate() - 7);
      }else if(flag == '1MONTH'){
        startDate.setMonth(endDate.getMonth() - 1);
      }else if(flag == '6MONTH'){
        startDate.setMonth(endDate.getMonth() - 6);
      }else if(flag == '1YEAR'){
        startDate.setFullYear(endDate.getFullYear() - 1);
      }
      this.fullDateTmp = [startDate, endDate];
      if(flag == 'ALL'){
        this.fullDateTmp = [];
      }
      this.handleDateRangeChange();
    },
    handleDateRangeChange() {
      this.queryParams.start_date = this.getFormatDate(this.fullDateTmp[0])
      this.queryParams.end_date = this.getFormatDate(this.fullDateTmp[1])
    },
    getFormatDate(date) {
      if (!date) return;
      return moment(date).format("YYYY-MM-DD");
    },
  },


}

function reportCodeReturn(urlcode){
  // trendbrief
  // indepthreport
  // surveyreport
  // visualbrief
  var reportCodeDatas = {};
  if(urlcode == 'trendbrief'){
    reportCodeDatas.depth_top_name = '트렌드브리프';
    reportCodeDatas.dr_topdeth = 'RPT_TYPE_1';
    reportCodeDatas.dr_unique = 'TB';
  }else if(urlcode == 'indepthreport'){
    reportCodeDatas.depth_top_name = '인뎁스리포트';
    reportCodeDatas.dr_topdeth = 'RPT_TYPE_2';
    reportCodeDatas.dr_unique = 'IR';
  }else if(urlcode == 'surveyreport'){
    reportCodeDatas.depth_top_name = '서베이리포트';
    reportCodeDatas.dr_topdeth = 'RPT_TYPE_3';
    reportCodeDatas.dr_unique = 'SR';
  }else if(urlcode == 'visualbrief'){
    reportCodeDatas.depth_top_name = '비쥬얼브리프';
    reportCodeDatas.dr_topdeth = 'RPT_TYPE_4';
    reportCodeDatas.dr_unique = 'VB';
  }
  return reportCodeDatas;
}
</script>
<style lang="css" scoped>
  .delete_button_on {color:#ffffff; border-radius:5px; cursor:pointer; border:1px solid #f42f2d; font-size:15px}
  .delete_button_off {color:#ffffff; border-radius:5px; cursor:auto; border:1px solid #f42f2d; font-size:15px}
  .clear_button_on {color:#ffffff; border-radius:5px; cursor:pointer; border:1px solid #55a0bb; font-size:15px}
  .clear_button_off {color:#ffffff; border-radius:5px; cursor:auto; border:1px solid #55a0bb; font-size:15px}
  .status-card .card-body {
    padding-bottom: 0 !important;
  }
</style>
<style src="daterangepicker/daterangepicker.css">



// WEBPACK FOOTER //
// src/views/contents/ContentsList.vue